import React from "react";

import SaleInformationBNBN from "./SaleInformationBNBN";
import SaleInformationPB from "./SaleInformationPB";

export interface SaleInformationProps {
  biddingType: "ProxyBid" | "BidNowBuyNow";
  saleName: string;
  publishedName: string;
  startDate: string;
  endDate: string;
  sectionName: string;
  localSaleLocation: string;
  saleLocation?: string;
  saleLocationUrl: string;
  lolCode: string;
  status: string;
  numberOfLots: number;
  vehicleLocationDescription?: string;
}

const SaleInformation: React.FunctionComponent<SaleInformationProps> = ({
  biddingType,
  saleName,
  publishedName,
  startDate,
  endDate,
  sectionName,
  localSaleLocation,
  saleLocation,
  saleLocationUrl,
  lolCode,
  status,
  numberOfLots,
  vehicleLocationDescription,
}) => {
  return (
    <>
      {biddingType === "BidNowBuyNow" && (
        <SaleInformationBNBN
          saleName={saleName}
          startDate={startDate}
          endDate={endDate}
          sectionName={sectionName}
          localSaleLocation={localSaleLocation}
          saleLocationUrl={saleLocationUrl}
          vehicleLocationDescription={vehicleLocationDescription}
        />
      )}
      {biddingType === "ProxyBid" && (
        <SaleInformationPB
          publishedName={publishedName}
          startDate={startDate}
          sectionName={sectionName}
          localSaleLocation={localSaleLocation}
          saleLocation={saleLocation}
          saleLocationUrl={saleLocationUrl}
          lolCode={lolCode}
          status={status}
          numberOfLots={numberOfLots}
          vehicleLocationDescription={vehicleLocationDescription}
        />
      )}
    </>
  );
};

export default SaleInformation;
